var map = {
	"./applepay.svg": 9959,
	"./googlepay.svg": 81515,
	"./maestro.svg": 23482,
	"./mastercard.svg": 92367,
	"./paypal.svg": 50674,
	"./visa.svg": 9577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3448;